export const storageQuestions = {
  conversation1: {
    id: 1,
    title: "Company Sports Event",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage1.mp3",
        script: `<mark>W</mark>: Hey, Tom. Are you participating in the company's annual <mark>sports day</mark> next month?
<span class="translation">(안녕하세요, Tom. 다음 달에 있을 회사 연례 체육대회에 참가하시나요?)</span>

<mark>M</mark>: I might. What activities are included <mark>this year</mark>?
<span class="translation">(그럴 것 같아요. 올해는 어떤 종목들이 있나요?)</span>

<mark>W</mark>: We'll have soccer, basketball, and relay races. They're also introducing a new <mark>obstacle course</mark> event.
<span class="translation">(축구, 농구, 릴레이가 있어요. 새로운 장애물 코스 종목도 도입한대요.)</span>

<mark>M</mark>: That sounds fun. How do I sign up?
<span class="translation">(재미있겠네요. 어떻게 신청하나요?)</span>

<mark>W</mark>: Just fill out the registration form on the company's <mark>website</mark> by Friday.
<span class="translation">(금요일까지 회사 웹사이트에서 등록 양식을 작성하시면 돼요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question:
          "What type of event are <mark>the speakers</mark> discussing?",
        options: {
          A: "A company <mark>sports competition</mark>",
          B: "A team-building <mark>workshop</mark>",
          C: "A corporate <mark>training</mark> <mark>session</mark>",
          D: "A <mark>volunteer</mark> <mark>event</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A company sports competition

대본 키워드: "Are you participating in the company's annual sports day?"
보기 키워드: "A company sports competition"

❌ 오답 트랩:
(B) A team-building workshop 
→ 팀 빌딩이 아닌 체육대회

(C) A corporate training session 
→ 교육이 아닌 체육 행사

(D) A volunteer event 
→ 자원봉사가 아닌 체육 행사`,
      },
      {
        id: 2,
        question: "What new event has been added <mark>this year</mark>?",
        options: {
          A: "A <mark>swimming</mark> competition",
          B: "An <mark>obstacle</mark> course",
          C: "A <mark>weightlifting</mark> challenge",
          D: "A <mark>rock climbing</mark> contest",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) An obstacle course

대본 키워드: "They're also introducing a new obstacle course event."
보기 키워드: "An obstacle course"

❌ 오답 트랩:
(A) A swimming competition 
→ 수영 대회 언급 없음

(C) A weightlifting challenge 
→ 역도 대회 언급 없음

(D) A rock climbing contest 
→ 암벽 등반 대회 언급 없음`,
      },
      {
        id: 3,
        question: "How can employees register for the event?",
        options: {
          A: "By calling the <mark>HR</mark> <mark>department</mark>",
          B: "By filling out a form <mark>online</mark>",
          C: "By signing up at the <mark>venue</mark>",
          D: "By getting approval from a <mark>manager</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) By filling out a form online

대본 키워드: "Just fill out the registration form on the company's website by Friday."
보기 키워드: "By filling out a form online"

❌ 오답 트랩:
(A) By calling the HR department 
→ HR 부서 전화 언급 없음

(C) By signing up at the venue 
→ 현장 등록 언급 없음

(D) By getting approval from a manager 
→ 매니저 승인 언급 없음`,
      },
    ],
  },
  conversation2: {
    id: 2,
    title: "Meeting Room Reservation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage2.mp3",
        script: `M: Hi, Lisa. Have you <mark>booked a conference room</mark> for the client presentation next Thursday?
<span class="translation">(안녕하세요, Lisa. 다음 주 목요일 고객 프레젠테이션을 위한 회의실 예약은 하셨나요?)</span>

W: Not yet. I checked the schedule, and our <mark>usual meeting room</mark> is already <mark>reserved</mark>.
<span class="translation">(아니요, 아직이요. 일정을 확인해보니 우리가 주로 쓰는 회의실이 이미 예약되어 있네요.)</span>

M: Oh, that's an issue. Are there any other <mark>available rooms</mark>?
<span class="translation">(아, 그거 문제네요. 다른 가용한 회의실이 있나요?)</span>

W: Yes, the <mark>smaller room</mark> on the second floor is free at <mark>2 PM</mark>. Should I reserve that?
<span class="translation">(네, 2층에 있는 작은 회의실이 오후 2시에 비어있습니다. 그걸로 예약할까요?)</span>

M: That works. I'll <mark>update the invitation</mark> to reflect the new location.
<span class="translation">(좋습니다. 새로운 장소를 반영해서 초대장을 업데이트하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem does <mark>the woman</mark> mention?",
        options: {
          A: "The <mark>projector</mark> is not working",
          B: "The <mark>usual meeting room</mark> is unavailable",
          C: "The <mark>client</mark> cannot attend the meeting",
          D: "The meeting <mark>time</mark> needs to be changed",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The usual meeting room is unavailable

대본 키워드: "I checked the schedule, and our usual meeting room is already reserved."
보기 키워드: "The usual meeting room is unavailable"
완전히 일치하는 정보가 있어 정답 확실

❌ 오답 트랩:
(A) The projector is not working → 기술 문제 언급 없음
(C) The client cannot attend the meeting → 고객 참석 관련 내용 없음
(D) The meeting time needs to be changed → 시간 변경이 아니라 장소 변경`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> suggest?",
        options: {
          A: "Booking a <mark>smaller room</mark>",
          B: "<mark>Rescheduling</mark> the meeting",
          C: "Holding the meeting <mark>online</mark>",
          D: "Using an <mark>outdoor space</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Booking a smaller room

대본 키워드: "Yes, the smaller room on the second floor is free at 2 PM."
보기 키워드: "Booking a smaller room"

❌ 오답 트랩:
(B) Rescheduling the meeting → 시간 변경이 아니라 장소 변경
(C) Holding the meeting online → 온라인 회의 언급 없음
(D) Using an outdoor space → 야외 공간 관련 내용 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> do next?",
        options: {
          A: "Update the <mark>invitation</mark>",
          B: "Call the <mark>IT department</mark>",
          C: "Postpone <mark>the meeting</mark>",
          D: "Cancel <mark>the booking</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Update the invitation

대본 키워드: "I'll update the invitation to reflect the new location."
보기 키워드: "Update the invitation"

❌ 오답 트랩:
(B) Call the IT department → 기술 문제 아님
(C) Postpone the meeting → 시간 변경 아님
(D) Cancel the booking → 예약을 새로 하는 것이지 취소 아님`,
      },
    ],
  },
  conversation3: {
    id: 3,
    title: "Checking Availability",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage3.mp3",
        script: `M: Hi, Olivia. Are you <mark>available</mark> for the <mark>strategy meeting</mark> next Wednesday at 10 AM?
<span class="translation">(안녕하세요, Olivia. 다음 주 수요일 오전 10시 전략 회의에 참석 가능하신가요?)</span>

W: I'd love to attend, but I'll be <mark>out of town</mark> for a <mark>client visit</mark> that day.
<span class="translation">(참석하고 싶지만, 그날 고객 방문차 출장을 가야 해서요.)</span>

M: Oh, that's unfortunate. Should we reschedule, or would you prefer to <mark>join remotely</mark>?
<span class="translation">(아, 그렇군요. 일정을 변경할까요, 아니면 원격으로 참여하시겠어요?)</span>

W: If possible, I'd like to <mark>join online</mark>. Can you send me a <mark>video call link</mark>?
<span class="translation">(가능하다면 온라인으로 참여하고 싶습니다. 화상 통화 링크를 보내주실 수 있나요?)</span>

M: Sure, I'll arrange that and send you the details by email.
<span class="translation">(네, 준비해서 이메일로 세부사항을 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the man</mark> ask <mark>the woman</mark>?",
        options: {
          A: "Whether she has completed a <mark>report</mark>",
          B: "If she can <mark>attend a meeting</mark>",
          C: "When she will be back from her <mark>trip</mark>",
          D: "If she needs assistance with a <mark>presentation</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) If she can attend a meeting

대본 키워드: "Are you available for the strategy meeting next Wednesday at 10 AM?"
보기 키워드: "If she can attend a meeting"
"Are you available" → "If she can attend"으로 자연스럽게 연결

❌ 오답 트랩:
(A) Whether she has completed a report → 보고서 관련 언급 없음
(C) When she will be back from her trip → 돌아오는 날짜 언급 없음
(D) If she needs assistance with a presentation → 발표 관련 내용 없음`,
      },
      {
        id: 2,
        question: "Why is <mark>the woman</mark> unable to attend in person?",
        options: {
          A: "She has another <mark>meeting</mark> scheduled",
          B: "She will be on a <mark>business trip</mark>",
          C: "The <mark>meeting room</mark> is too far away",
          D: "She needs to finalize a <mark>report</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) She will be on a business trip

대본 키워드: "I'll be out of town for a client visit that day."
보기 키워드: "She will be on a business trip"
"Out of town for a client visit" → "On a business trip"으로 자연스럽게 변환

❌ 오답 트랩:
(A) She has another meeting scheduled → 다른 일정이 아니라 출장
(C) The meeting room is too far away → 위치 문제 언급 없음
(D) She needs to finalize a report → 보고서 마감 관련 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Send her a <mark>video call link</mark>",
          B: "Reschedule the <mark>meeting</mark> for another day",
          C: "Ask a <mark>colleague</mark> to replace her",
          D: "Move the meeting to a <mark>larger room</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Send her a video call link

대본 키워드: "Can you send me a video call link?" / "Sure, I'll arrange that and send you the details by email."
보기 키워드: "Send her a video call link"
행동을 그대로 반영하여 정답 명확히 유도

❌ 오답 트랩:
(B) Reschedule the meeting for another day → 시간 변경 없이 온라인 참석 선택
(C) Ask a colleague to replace her → 대체 인원 요청 언급 없음
(D) Move the meeting to a larger room → 장소 변경 관련 없음`,
      },
    ],
  },
  conversation4: {
    id: 4,
    title: "Meeting Time Change",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage4.mp3",
        script: `<mark>M</mark>: Hi, Jenna. I just got an email from Mr. Lee. He needs to <mark>move our quarterly performance meeting</mark> from Wednesday <mark>morning</mark> to the <mark>afternoon</mark>.
<span class="translation">(안녕하세요, Jenna. 방금 Lee 씨에게서 이메일을 받았어요. 수요일 오전에 예정된 분기별 성과 회의를 오후로 옮겨야 한다고 하네요.)</span>

<mark>W</mark>: That shouldn't be a problem. Does he have a specific time in mind?
<span class="translation">(문제 없을 것 같아요. 특정 시간대를 말씀하셨나요?)</span>

<mark>M</mark>: Yes, he prefers <mark>2 PM</mark> instead of <mark>10 AM</mark>.
<span class="translation">(네, 오전 10시 대신 오후 2시를 선호하신다고 합니다.)</span>

<mark>W</mark>: I'll <mark>update the calendar</mark> and <mark>inform the other attendees</mark>.
<span class="translation">(캘린더를 업데이트하고 다른 참석자들에게 알리도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What change is being made to the meeting?",
        options: {
          A: "The <mark>location</mark> is being changed",
          B: "The meeting will be postponed until <mark>next week</mark>",
          C: "The <mark>time</mark> of <mark>the meeting</mark> is being changed",
          D: "The meeting <mark>duration</mark> is being shortened",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The time of the meeting is being changed

대본 키워드: "He needs to move our quarterly performance meeting from Wednesday morning to the afternoon."
보기 키워드: "The time of the meeting is being changed"
"Move the meeting" → "The time is being changed"으로 자연스럽게 연결

❌ 오답 트랩:
(A) The location is being changed → 장소 변경 언급 없음
(B) The meeting will be postponed until next week → 같은 날 오후로 변경됨, 연기 아님
(D) The meeting duration is being shortened → 시간이 바뀌었을 뿐, 길이 변경 없음`,
      },
      {
        id: 2,
        question: "Why is the change being made?",
        options: {
          A: "The presenter is unavailable <mark>in the morning</mark>",
          B: "The <mark>original schedule</mark> was incorrect",
          C: "The <mark>meeting room</mark> is under maintenance",
          D: "<mark>Another</mark> <mark>event</mark> is happening at that time",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The presenter is unavailable in the morning

대본 키워드: "Mr. Lee needs to move our quarterly performance meeting."
보기 키워드: "The presenter is unavailable in the morning"
"Mr. Lee needs to move the meeting" → "The presenter is unavailable"로 의미 변형 적용

❌ 오답 트랩:
(B) The original schedule was incorrect → 잘못된 일정이 아니라 변경 요청임
(C) The meeting room is under maintenance → 회의실 관련 문제 없음
(D) Another event is happening at that time → 다른 일정 충돌 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Update the <mark>calendar</mark> and notify the attendees",
          B: "Find a new <mark>location</mark> for the meeting",
          C: "<mark>Reschedule</mark> the meeting for <mark>next month</mark>",
          D: "<mark>Cancel</mark> the meeting entirely",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Update the calendar and notify the attendees

대본 키워드: "I'll update the calendar and inform the other attendees."
보기 키워드: "Update the calendar and notify the attendees"

❌ 오답 트랩:
(B) Find a new location for the meeting → 회의실 변경이 아니라 시간 변경
(C) Reschedule the meeting for next month → 같은 날 오후로 변경됨, 연기 아님
(D) Cancel the meeting entirely → 취소가 아니라 시간 조정`,
      },
    ],
  },
  conversation5: {
    id: 5,
    title: "Meeting Room Reservation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage5.mp3",
        script: `<mark>W</mark>: Hi, Kevin. I was checking the schedule for tomorrow's department meeting. It looks like our <mark>usual conference room</mark> is already <mark>booked</mark>.
<span class="translation">(안녕하세요, Kevin. 내일 부서 회의 일정을 확인해보니 우리가 주로 쓰는 회의실이 이미 예약되어 있네요.)</span>

<mark>M</mark>: That's a problem. Are there any other <mark>available rooms</mark>?
<span class="translation">(그건 문제네요. 다른 가용한 회의실이 있나요?)</span>

<mark>W</mark>: The only available space is the <mark>small meeting room</mark> on the <mark>third floor</mark>.
<span class="translation">(3층에 있는 작은 회의실만 비어있습니다.)</span>

<mark>M</mark>: That should work. Let's <mark>book it</mark> and <mark>inform the team</mark>.
<span class="translation">(그걸로 괜찮겠네요. 예약하고 팀에 알리도록 하죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What issue is <mark>the woman</mark> reporting?",
        options: {
          A: "The <mark>meeting date</mark> is incorrect",
          B: "The <mark>meeting room</mark> is unavailable",
          C: "The <mark>projector</mark> is not working",
          D: "The <mark>speaker</mark> cannot attend",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The meeting room is unavailable

대본 키워드: "Our usual conference room is already booked."
보기 키워드: "The meeting room is unavailable"

❌ 오답 트랩:
(A) The meeting date is incorrect → 날짜 문제 언급 없음
(C) The projector is not working → 장비 문제 언급 없음
(D) The speaker cannot attend → 발표자 관련 언급 없음`,
      },
      {
        id: 2,
        question: "Where will the meeting take place instead?",
        options: {
          A: "The <mark>cafeteria</mark>",
          B: "The <mark>large conference hall</mark>",
          C: "The <mark>small meeting room</mark> on the <mark>third floor</mark>",
          D: "A <mark>coworking space</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The small meeting room on the third floor

대본 키워드: "The only available space is the small meeting room on the third floor."
보기 키워드: "The small meeting room on the third floor"

❌ 오답 트랩:
(A) The cafeteria → 식당 언급 없음
(B) The large conference hall → 작은 회의실로 이동, 큰 회의실 언급 없음
(D) A coworking space → 공유 오피스 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Confirm</mark> the reservation and notify <mark>the team</mark>",
          B: "<mark>Cancel</mark> the meeting",
          C: "Contact the <mark>IT department</mark>",
          D: "<mark>Reschedule</mark> the meeting for a <mark>different day</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Confirm the reservation and notify the team

대본 키워드: "That should work. Let's book it and inform the team."
보기 키워드: "Confirm the reservation and notify the team"

❌ 오답 트랩:
(B) Cancel the meeting → 취소가 아니라 장소 변경
(C) Contact the IT department → 기술 문제 언급 없음
(D) Reschedule the meeting for a different day → 시간 변경이 아니라 장소 변경`,
      },
    ],
  },
  conversation6: {
    id: 6,
    title: "Checking Availability",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage6.mp3",
        script: `<mark>W</mark>: Hi, Peter. I wanted to check if you'll be able to <mark>join the regional sales meeting</mark> on Thursday at <mark>3 PM</mark>.
<span class="translation">(안녕하세요, Peter. 목요일 오후 3시 지역 영업 회의에 참석 가능하신지 확인하고 싶었어요.)</span>

<mark>M</mark>: Oh, I had completely forgotten about that. I have a <mark>client call</mark> scheduled at that time.
<span class="translation">(아, 완전히 잊고 있었네요. 그 시간에 고객과의 통화가 예정되어 있습니다.)</span>

<mark>W</mark>: That's unfortunate. Would you be able to join for at least <mark>part of the meeting</mark>?
<span class="translation">(안타깝네요. 적어도 회의 일부라도 참석하실 수 있나요?)</span>

<mark>M</mark>: I'll see if I can adjust my schedule, but I may only be available for the <mark>last 30 minutes</mark>.
<span class="translation">(일정을 조정할 수 있는지 보겠지만, 마지막 30분만 가능할 것 같습니다.)</span>

<mark>W</mark>: That would still be helpful. I'll <mark>send you a summary</mark> beforehand so you can catch up quickly.
<span class="translation">(그래도 도움이 될 것 같아요. 미리 요약본을 보내드릴 테니 빨리 따라잡으실 수 있을 거예요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the woman</mark> ask <mark>the man</mark>?",
        options: {
          A: "If he can <mark>lead</mark> <mark>the meeting</mark>",
          B: "Whether he is <mark>available</mark> to <mark>attend</mark>",
          C: "When he will finish his <mark>report</mark>",
          D: "If he can present <mark>financial data</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Whether he is available to attend

대본 키워드: "I wanted to check if you'll be able to join the regional sales meeting on Thursday at 3 PM."
보기 키워드: "Whether he is available to attend"
"Check if you'll be able to join" → "Whether he is available to attend"로 자연스럽게 변환

❌ 오답 트랩:
(A) If he can lead the meeting → 리더 역할 요청 언급 없음
(C) When he will finish his report → 보고서 관련 언급 없음
(D) If he can present financial data → 재무 데이터 발표 언급 없음`,
      },
      {
        id: 2,
        question:
          "Why is <mark>the man</mark> unable to attend the full meeting?",
        options: {
          A: "He has a <mark>flight</mark> to catch",
          B: "He has a <mark>client call</mark> at that time",
          C: "The <mark>meeting time</mark> was changed unexpectedly",
          D: "He is attending <mark>another</mark> <mark>conference</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) He has a client call at that time

대본 키워드: "I have a client call scheduled at that time."
보기 키워드: "He has a client call at that time"
완전히 일치하는 정보가 있어 정답 확실

❌ 오답 트랩:
(A) He has a flight to catch → 항공편 관련 언급 없음
(C) The meeting time was changed unexpectedly → 일정 변경이 아니라 기존 일정과 겹침
(D) He is attending another conference → 회의가 아니라 클라이언트 미팅이 이유`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Send him a <mark>summary</mark> of the meeting",
          B: "<mark>Reschedule</mark> the meeting to a different day",
          C: "Ask <mark>another</mark> employee to <mark>replace</mark> him",
          D: "<mark>Extend</mark> the meeting <mark>duration</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Send him a summary of the meeting

대본 키워드: "I'll send you a summary beforehand so you can catch up quickly."
보기 키워드: "Send him a summary of the meeting"

❌ 오답 트랩:
(B) Reschedule the meeting to a different day → 회의 일정 변경 언급 없음
(C) Ask another employee to replace him → 대체 인원 요청 언급 없음
(D) Extend the meeting duration → 회의 연장 언급 없음`,
      },
    ],
  },
  conversation7: {
    id: 7,
    title: "Submitting a Report",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage7.mp3",
        script: `<mark>W</mark>: Hi, Daniel. I just wanted to check if the <mark>quarterly sales report</mark> is ready. It's due by <mark>10 AM tomorrow</mark>.
<span class="translation">(안녕하세요, Daniel. 분기별 매출 보고서가 준비되었는지 확인하고 싶었어요. 내일 오전 10시까지 제출해야 하거든요.)</span>

<mark>M</mark>: I've completed most of it, but I still need to <mark>verify some financial figures</mark> with the <mark>accounting team</mark>.
<span class="translation">(대부분 완성했지만, 회계팀과 일부 재무 수치를 확인해야 합니다.)</span>

<mark>W</mark>: Can you get that done today? The <mark>director</mark> needs the final version first thing in the morning.
<span class="translation">(오늘 안으로 완료할 수 있나요? 이사님께서 내일 아침 첫 일정으로 최종본이 필요하시거든요.)</span>

<mark>M</mark>: Yes, I'll <mark>finalize everything tonight</mark> and submit it before the <mark>deadline</mark>.
<span class="translation">(네, 오늘 밤에 모두 마무리해서 기한 전에 제출하도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A new <mark>budget proposal</mark>",
          B: "A delay in <mark>product shipment</mark>",
          C: "A <mark>sales report</mark> submission",
          D: "An upcoming <mark>presentation</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A sales report submission

대본 키워드: "I just wanted to check if the quarterly sales report is ready. It's due by 10 AM tomorrow."
보기 키워드: "A sales report submission"
"quarterly sales report" → "A sales report submission"으로 자연스럽게 변환

❌ 오답 트랩:
(A) A new budget proposal → 예산안 관련 내용 없음
(B) A delay in product shipment → 배송 지연 언급 없음
(D) An upcoming presentation → 발표 관련 언급 없음`,
      },
      {
        id: 2,
        question: "Why has <mark>the man</mark> not completed the report?",
        options: {
          A: "He has not received some <mark>financial data</mark>",
          B: "The reporting <mark>software</mark> is malfunctioning",
          C: "He has been too <mark>busy</mark> with other tasks",
          D: "The <mark>deadline</mark> was moved up unexpectedly",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) He has not received some financial data

대본 키워드: "I still need to verify some financial figures with the accounting team."
보기 키워드: "He has not received some financial data"
"Verify financial figures" → "Received some financial data"로 자연스럽게 변환

❌ 오답 트랩:
(B) The reporting software is malfunctioning → 소프트웨어 문제 언급 없음
(C) He has been too busy with other tasks → 다른 업무로 인한 지연 언급 없음
(D) The deadline was moved up unexpectedly → 마감 기한 변경 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Finalize</mark> the report and submit it",
          B: "Ask for a deadline <mark>extension</mark>",
          C: "<mark>Cancel</mark> the report submission",
          D: "Meet with the <mark>marketing team</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Finalize the report and submit it

대본 키워드: "I'll finalize everything tonight and submit it before the deadline."
보기 키워드: "Finalize the report and submit it"

❌ 오답 트랩:
(B) Ask for a deadline extension → 연장 요청 없이 정해진 기한을 지키겠다고 말함
(C) Cancel the report submission → 취소가 아니라 제출 예정
(D) Meet with the marketing team → 회계팀과 데이터 검토 필요, 마케팅팀 언급 없음`,
      },
    ],
  },

  conversation8: {
    id: 9,
    title: "Reviewing Data Requests",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage9.mp3",
        script: `<mark>W</mark>: Hi, David. Before we finalize the <mark>quarterly financial analysis</mark>, I want to make sure the data from the sales team is accurate.
<span class="translation">(안녕하세요, David. 분기별 재무 분석을 마무리하기 전에, 영업팀의 데이터가 정확한지 확인하고 싶어요.)</span>

<mark>M</mark>: I checked most of the numbers this morning, but a few figures in the <mark>revenue report</mark> don't match.
<span class="translation">(오늘 아침에 대부분의 숫자를 확인했는데, 매출 보고서의 일부 수치가 일치하지 않습니다.)</span>

<mark>W</mark>: That's a concern. Can you double-check with the <mark>sales department</mark>? We need to submit the final report by tomorrow afternoon.
<span class="translation">(그건 문제네요. 영업부와 다시 한 번 확인해볼 수 있나요? 내일 오후까지 최종 보고서를 제출해야 해요.)</span>

<mark>M</mark>: I'll <mark>reach out to them now</mark> and confirm everything before the deadline.
<span class="translation">(지금 바로 연락해서 마감 전까지 모든 것을 확인하도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "Preparing a <mark>budget proposal</mark>",
          B: "Reviewing <mark>financial data</mark>",
          C: "Organizing a company <mark>meeting</mark>",
          D: "Conducting <mark>employee evaluations</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Reviewing financial data

대본 키워드: "Before we finalize the quarterly financial analysis."
보기 키워드: "Reviewing financial data"
"Finalizing financial analysis" → "Reviewing financial data"로 자연스럽게 변환

❌ 오답 트랩:
(A) Preparing a budget proposal → 예산안이 아니라 데이터 검토 중
(C) Organizing a company meeting → 회의 기획 관련 언급 없음
(D) Conducting employee evaluations → 직원 평가 언급 없음`,
      },
      {
        id: 2,
        question: "What issue does <mark>the man</mark> mention?",
        options: {
          A: "Some <mark>revenue figures</mark> do not match",
          B: "The report is missing key <mark>sections</mark>",
          C: "The <mark>deadline</mark> has been moved up",
          D: "The <mark>finance team</mark> is understaffed",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Some revenue figures do not match

대본 키워드: "A few figures in the revenue report don't match."
보기 키워드: "Some revenue figures do not match"
완전히 일치하는 정보가 있어 정답 확실

❌ 오답 트랩:
(B) The report is missing key sections → 데이터 오류지, 보고서 일부 누락이 아님
(C) The deadline has been moved up → 마감 기한 변경 언급 없음
(D) The finance team is understaffed → 인력 부족 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Contact the <mark>sales department</mark>",
          B: "Request a <mark>deadline extension</mark>",
          C: "<mark>Submit the report</mark> as it is",
          D: "<mark>Ask</mark> his <mark>colleague</mark> to assist with the calculations",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Contact the sales department

대본 키워드: "I'll reach out to them now and confirm everything before the deadline."
보기 키워드: "Contact the sales department"

❌ 오답 트랩:
(B) Request a deadline extension → 연장 요청 언급 없음
(C) Submit the report as it is → 데이터 확인 후 제출 계획
(D) Ask his colleague to assist with the calculations → 동료 도움 요청 언급 없음`,
      },
    ],
  },
  conversation9: {
    id: 10,
    title: "Workshop",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage10.mp3",
        script: `<mark>W</mark>: Hi, James. Are you planning to attend the <mark>team-building workshop</mark> next Friday?
<span class="translation">(안녕하세요, James. 다음 주 금요일 팀 빌딩 워크숍에 참석할 계획인가요?)</span>

<mark>M</mark>: I wasn't sure if I should sign up. Is it <mark>mandatory</mark>?
<span class="translation">(신청해야 하는지 확실하지 않았어요. 필수인가요?)</span>

<mark>W</mark>: No, it's <mark>optional</mark>, but highly recommended. It will focus on improving <mark>collaboration</mark> and <mark>leadership</mark> skills.
<span class="translation">(아니요, 선택사항이지만 적극 추천드려요. 협업과 리더십 스킬 향상에 초점을 맞출 거예요.)</span>

<mark>M</mark>: That sounds useful. Where is it being held?
<span class="translation">(유용할 것 같네요. 어디서 진행되나요?)</span>

<mark>W</mark>: In the corporate <mark>training center</mark>. The registration <mark>deadline</mark> is Wednesday afternoon.
<span class="translation">(기업 연수원에서요. 등록 마감은 수요일 오후예요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A <mark>corporate training</mark> session",
          B: "A company-wide <mark>conference</mark>",
          C: "A <mark>department</mark> <mark>meeting</mark>",
          D: "A leadership <mark>promotion</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A corporate training session

대본 키워드: "Are you planning to attend the team-building workshop next Friday?"
보기 키워드: "A corporate training session"

❌ 오답 트랩:
(B) A company-wide conference 
→ 워크숍이지 전체 컨퍼런스 아님

(C) A department meeting 
→ 팀 빌딩 행사이지 부서 회의 아님

(D) A leadership promotion 
→ 승진과 관련 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> say about the workshop?",
        options: {
          A: "It is required for <mark>new</mark> <mark>employees</mark>",
          B: "It will cover <mark>teamwork</mark> and <mark>leadership</mark> <mark>skills</mark>",
          C: "It will take place in an <mark>outdoor</mark> venue",
          D: "Employees must submit a <mark>report</mark> afterward",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) It will cover teamwork and leadership skills

대본 키워드: "It will focus on improving collaboration and leadership skills."
보기 키워드: "It will cover teamwork and leadership skills"

❌ 오답 트랩:
(A) It is required for new employees 
→ 필수 행사 아님 ("optional"으로 언급됨)

(C) It will take place in an outdoor venue 
→ 실내(기업 연수 센터)에서 진행됨

(D) Employees must submit a report afterward 
→ 보고서 제출 언급 없음`,
      },
      {
        id: 3,
        question: "What must <mark>the man</mark> do if he wants to attend?",
        options: {
          A: "Complete an <mark>online training</mark> first",
          B: "Confirm his attendance by <mark>Wednesday</mark>",
          C: "Pay a <mark>participation</mark> <mark>fee</mark>",
          D: "Speak with his <mark>department</mark> <mark>manager</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Confirm his attendance by Wednesday

대본 키워드: "The registration deadline is Wednesday afternoon."
보기 키워드: "Confirm his attendance by Wednesday"

❌ 오답 트랩:
(A) Complete an online training first 
→ 사전 온라인 교육 언급 없음

(C) Pay a participation fee 
→ 참가비 언급 없음

(D) Speak with his department manager 
→ 부서장 상담 언급 없음`,
      },
    ],
  },

  conversation10: {
    id: 11,
    title: "Project Timeline Adjustment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage11.mp3",
        script: `<mark>M</mark>: Lisa, I wanted to discuss the <mark>website redesign project</mark>. The initial deadline is next Friday, but we might need <mark>more time</mark>.
<span class="translation">(Lisa, 웹사이트 리디자인 프로젝트에 대해 논의하고 싶었어요. 최초 마감일이 다음 주 금요일인데, 시간이 더 필요할 것 같습니다.)</span>

<mark>W</mark>: What's causing the delay? Are we behind on content development?
<span class="translation">(지연의 원인이 뭔가요? 콘텐츠 개발이 늦어지고 있나요?)</span>

<mark>M</mark>: Not exactly. The developers encountered unexpected <mark>compatibility issues</mark> when integrating the new design. They estimate that fixing it will take an <mark>extra three days</mark>.
<span class="translation">(그건 아니에요. 개발자들이 새로운 디자인을 통합하는 과정에서 예상치 못한 호환성 문제가 발생했어요. 수정하는 데 3일이 더 걸릴 것으로 예상합니다.)</span>

<mark>W</mark>: If that's the case, should we request a <mark>deadline extension</mark> from the client?
<span class="translation">(그렇다면, 고객에게 기한 연장을 요청해야 할까요?)</span>

<mark>M</mark>: Let me check with the <mark>development team</mark> first. If they confirm the additional time is necessary, I'll inform the client this afternoon.
<span class="translation">(먼저 개발팀과 확인해보겠습니다. 추가 시간이 필요하다고 확인되면, 오후에 고객에게 알리도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the speakers'</mark> concern?",
        options: {
          A: "The project <mark>budget</mark> was <mark>cut</mark>",
          B: "A project <mark>milestone</mark> might be <mark>delayed</mark>",
          C: "A <mark>software bug</mark> is affecting the design",
          D: "A key <mark>team member</mark> is <mark>leaving</mark> the company",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A project milestone might be delayed

대본 키워드: "The initial deadline is next Friday, but we might need more time."
보기 키워드: "A project milestone might be delayed"

❌ 오답 트랩:
(A) The project budget was cut → 예산 삭감 언급 없음
(C) A software bug is affecting the design → 호환성 문제이지 버그가 아님
(D) A key team member is leaving the company → 팀원 이직 관련 언급 없음`,
      },
      {
        id: 2,
        question: "What is causing the delay?",
        options: {
          A: "The client requested new <mark>features</mark>",
          B: "A key supplier is late with a <mark>delivery</mark>",
          C: "The developers encountered <mark>compatibility issues</mark>",
          D: "The testing phase was <mark>postponed</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The developers encountered compatibility issues

대본 키워드: "The developers encountered unexpected compatibility issues when integrating the new design."
보기 키워드: "The developers encountered compatibility issues"

❌ 오답 트랩:
(A) The client requested new features → 새로운 기능 요청 없음
(B) A key supplier is late with a delivery → 공급업체 관련 언급 없음
(D) The testing phase was postponed → 테스트 단계 연기 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Inform</mark> the <mark>client</mark> about the delay",
          B: "Consult with the <mark>development team</mark>",
          C: "Request additional <mark>resources</mark>",
          D: "<mark>Cancel</mark> the project",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Consult with the development team

대본 키워드: "Let me check with the development team first."
보기 키워드: "Consult with the development team"

❌ 오답 트랩:
(A) Inform the client about the delay → 고객에게 알리기 전에 개발팀과 먼저 확인한다고 말함
(C) Request additional resources → 자원 요청 관련 언급 없음
(D) Cancel the project → 일정 연장 논의 중이지 프로젝트 취소 아님`,
      },
    ],
  },
  conversation11: {
    id: 12,
    title: "Computer Malfunction",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage12.mp3",
        script: `<mark>W</mark>: Hi, Brian. My <mark>computer keeps freezing</mark>, and I can't seem to <mark>save my files</mark> properly. It's been acting up since this morning.
<span class="translation">(안녕하세요, Brian. 컴퓨터가 계속 멈추고, 파일도 제대로 저장이 안 돼요. 오늘 아침부터 이상하게 작동하고 있어요.)</span>

<mark>M</mark>: That's strange. Have you tried <mark>restarting</mark> it?
<span class="translation">(이상하네요. 재시작은 해보셨나요?)</span>

<mark>W</mark>: Yes, but it still won't work. Should I submit an <mark>IT request</mark>?
<span class="translation">(네, 해봤는데도 작동하지 않아요. IT 지원 요청을 해야 할까요?)</span>

<mark>M</mark>: I think that's a good idea. I'll also check if there are any <mark>system updates</mark> that might be causing the issue.
<span class="translation">(좋은 생각인 것 같아요. 문제의 원인이 될 수 있는 시스템 업데이트가 있는지도 확인해보겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem does <mark>the woman</mark> mention?",
        options: {
          A: "Her <mark>files</mark> were accidentally <mark>deleted</mark>",
          B: "The <mark>computer</mark> is not <mark>responding</mark> properly",
          C: "The company <mark>network</mark> is down",
          D: "A <mark>software installation</mark> failed",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The computer is not responding properly

대본 키워드: "My computer keeps freezing, and I can't seem to save my files properly."
보기 키워드: "The computer is not responding properly"
"Freezing" → "Not responding properly"로 자연스럽게 변환

❌ 오답 트랩:
(A) Her files were accidentally deleted → 파일 삭제 언급 없음
(C) The company network is down → 네트워크 문제 언급 없음
(D) A software installation failed → 소프트웨어 설치 문제 언급 없음`,
      },
      {
        id: 2,
        question: "What has <mark>the woman</mark> already tried?",
        options: {
          A: "<mark>Restarting</mark> the computer",
          B: "Installing antivirus <mark>software</mark>",
          C: "Changing her <mark>password</mark>",
          D: "Moving her files to a backup <mark>drive</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Restarting the computer

대본 키워드: "I've already tried restarting it."
보기 키워드: "Restarting the computer"

❌ 오답 트랩:
(B) Installing antivirus software → 바이러스 관련 언급 없음
(C) Changing her password → 비밀번호 변경 언급 없음
(D) Moving her files to a backup drive → 백업 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Check for <mark>system updates</mark>",
          B: "Call the <mark>software provider</mark>",
          C: "Ask her to <mark>replace</mark> the <mark>computer</mark>",
          D: "Reinstall the <mark>operating system</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check for system updates

대본 키워드: "I'll also check if there are any system updates that might be causing the issue."
보기 키워드: "Check for system updates"

❌ 오답 트랩:
(B) Call the software provider → 외부 소프트웨어 업체 언급 없음
(C) Ask her to replace the computer → 교체가 아니라 문제 해결 과정 중
(D) Reinstall the operating system → 운영체제 재설치 언급 없음`,
      },
    ],
  },
  conversation12: {
    id: 13,
    title: "Printer & Copier Issue",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage13.mp3",
        script: `<mark>M</mark>: Lisa, do you know why the <mark>printer isn't working</mark>? I tried printing a document, but nothing is coming out.
<span class="translation">(Lisa, 프린터가 왜 작동하지 않는지 아시나요? 문서를 출력하려고 했는데 아무것도 나오지 않아요.)</span>

<mark>W</mark>: I noticed that earlier. It might be <mark>out of toner</mark>.
<span class="translation">(아까 봤어요. 토너가 떨어졌을 수 있어요.)</span>

<mark>M</mark>: That's possible. Where do we store <mark>extra cartridges</mark>?
<span class="translation">(그럴 수 있겠네요. 여분의 카트리지는 어디에 보관하나요?)</span>

<mark>W</mark>: I think there are some in the <mark>supply cabinet</mark>. I'll go check now.
<span class="translation">(비품 캐비닛에 있을 것 같아요. 지금 가서 확인해볼게요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem are <mark>the speakers</mark> experiencing?",
        options: {
          A: "The <mark>printer</mark> is not functioning",
          B: "A <mark>document</mark> was printed <mark>incorrectly</mark>",
          C: "The office <mark>Wi-Fi</mark> is disconnected",
          D: "The <mark>fax machine</mark> is out of order",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The printer is not functioning

대본 키워드: "Do you know why the printer isn't working?"
보기 키워드: "The printer is not functioning"

❌ 오답 트랩:
(B) A document was printed incorrectly → 문서 인쇄 오류가 아니라 출력이 안 되는 문제
(C) The office Wi-Fi is disconnected → 인터넷 문제 언급 없음
(D) The fax machine is out of order → 팩스기 문제 언급 없음`,
      },
      {
        id: 2,
        question:
          "What does <mark>the woman</mark> think is causing the issue?",
        options: {
          A: "The printer is out of <mark>toner</mark>",
          B: "The <mark>paper tray</mark> is jammed",
          C: "The wrong <mark>printer settings</mark> were used",
          D: "The machine <mark>overheated</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The printer is out of toner

대본 키워드: "It might be out of toner."
보기 키워드: "The printer is out of toner"

❌ 오답 트랩:
(B) The paper tray is jammed → 용지 걸림 언급 없음
(C) The wrong printer settings were used → 설정 문제 언급 없음
(D) The machine overheated → 과열 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Check the <mark>supply cabinet</mark>",
          B: "Call the <mark>IT department</mark>",
          C: "<mark>Restart</mark> the printer",
          D: "Ask a <mark>technician</mark> to repair the machine",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check the supply cabinet

대본 키워드: "I'll go check now."
보기 키워드: "Check the supply cabinet"

❌ 오답 트랩:
(B) Call the IT department → IT 부서 연락 언급 없음
(C) Restart the printer → 재시작 시도 언급 없음
(D) Ask a technician to repair the machine → 기술자 호출 언급 없음`,
      },
    ],
  },
  conversation13: {
    id: 14,
    title: "Telephone & Communication Equipment Issue",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage14.mp3",
        script: `<mark>W</mark>: John, are you having trouble with your <mark>desk phone</mark>? I can't make <mark>outgoing calls</mark>.
<span class="translation">(John, 책상 전화기에 문제가 있나요? 발신 전화를 걸 수가 없어요.)</span>

<mark>M</mark>: Yes, I had the same issue earlier. The <mark>phone line</mark> might be down.
<span class="translation">(네, 저도 아까 같은 문제가 있었어요. 전화선에 문제가 있는 것 같아요.)</span>

<mark>W</mark>: Should we report it to <mark>IT</mark>, or is there something we can try first?
<span class="translation">(IT 부서에 보고해야 할까요, 아니면 먼저 시도해볼 수 있는 게 있을까요?)</span>

<mark>M</mark>: Let's <mark>restart the phone system</mark> first. If that doesn't work, we'll call IT support.
<span class="translation">(먼저 전화 시스템을 재시작해봅시다. 그래도 안 되면 IT 지원팀에 연락하죠.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem is <mark>the woman</mark> experiencing?",
        options: {
          A: "The <mark>voicemail</mark> system is malfunctioning",
          B: "She cannot make <mark>outgoing calls</mark>",
          C: "The <mark>speakerphone</mark> is not working",
          D: "Her <mark>headset</mark> is broken",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) She cannot make outgoing calls

대본 키워드: "I can't make outgoing calls."
보기 키워드: "She cannot make outgoing calls"

❌ 오답 트랩:
(A) The voicemail system is malfunctioning → 음성메일 시스템 언급 없음
(C) The speakerphone is not working → 스피커폰 관련 언급 없음
(D) Her headset is broken → 헤드셋 문제 언급 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the man</mark> think is causing the issue?",
        options: {
          A: "A problem with the <mark>phone line</mark>",
          B: "A weak <mark>internet connection</mark>",
          C: "A <mark>software update</mark>",
          D: "A damaged <mark>phone cable</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A problem with the phone line

대본 키워드: "The phone line might be down."
보기 키워드: "A problem with the phone line"

❌ 오답 트랩:
(B) A weak internet connection → 인터넷 연결 언급 없음
(C) A software update → 소프트웨어 업데이트 언급 없음
(D) A damaged phone cable → 케이블 손상 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the speakers</mark> most likely do next?",
        options: {
          A: "<mark>Restart</mark> the phone system",
          B: "<mark>Contact</mark> the service provider",
          C: "<mark>Buy</mark> a new phone",
          D: "<mark>Use</mark> a different <mark>phone line</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Restart the phone system

대본 키워드: "Let's restart the phone system first."
보기 키워드: "Restart the phone system"

❌ 오답 트랩:
(B) Contact the service provider → 서비스 제공업체 연락 언급 없음
(C) Buy a new phone → 새 전화기 구매 언급 없음
(D) Use a different phone line → 다른 전화선 사용 언급 없음`,
      },
    ],
  },
  conversation14: {
    id: 15,
    title: "Unstable Internet Connection",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage15.mp3",
        script: `<mark>W</mark>: Hi, Ryan. Is your <mark>internet running slow</mark> today? My <mark>video calls</mark> keep disconnecting.
<span class="translation">(안녕하세요, Ryan. 오늘 인터넷이 느린가요? 화상 통화가 계속 끊기네요.)</span>

<mark>M</mark>: Yes, I noticed that too. I thought it was just my computer, but it seems like a <mark>network issue</mark>.
<span class="translation">(네, 저도 알았어요. 제 컴퓨터만의 문제인 줄 알았는데, 네트워크 문제인 것 같네요.)</span>

<mark>W</mark>: Should we <mark>restart the router</mark>? That usually helps when the connection is unstable.
<span class="translation">(라우터를 재시작해볼까요? 보통 연결이 불안정할 때 도움이 되거든요.)</span>

<mark>M</mark>: Let's try that first. If the problem persists, we might need to contact <mark>IT support</mark>.
<span class="translation">(먼저 그렇게 해보죠. 문제가 계속되면 IT 지원팀에 연락해야 할 것 같아요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem are <mark>the speakers</mark> experiencing?",
        options: {
          A: "The <mark>server</mark> is down for maintenance",
          B: "The <mark>network</mark> is unstable",
          C: "They lost access to their <mark>email</mark> accounts",
          D: "The office <mark>power supply</mark> is faulty",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The network is unstable

대본 키워드: "Is your internet running slow today?" / "It seems like a network issue."
보기 키워드: "The network is unstable"

❌ 오답 트랩:
(A) The server is down for maintenance → 서버 유지보수 언급 없음
(C) They lost access to their email accounts → 이메일 문제 언급 없음
(D) The office power supply is faulty → 전력 공급 문제 언급 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> suggest doing first?",
        options: {
          A: "Calling the <mark>IT department</mark>",
          B: "Restarting the <mark>router</mark>",
          C: "Using a different <mark>computer</mark>",
          D: "Switching to a mobile <mark>hotspot</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Restarting the router

대본 키워드: "Should we restart the router? That usually helps when the connection is unstable."
보기 키워드: "Restarting the router"

❌ 오답 트랩:
(A) Calling the IT department → IT 부서 연락은 두 번째 옵션
(C) Using a different computer → 다른 컴퓨터 사용 언급 없음
(D) Switching to a mobile hotspot → 모바일 핫스팟 언급 없음`,
      },
      {
        id: 3,
        question:
          "What will <mark>the man</mark> do next if the problem continues?",
        options: {
          A: "Switch to another <mark>network</mark>",
          B: "Contact <mark>IT support</mark>",
          C: "Postpone a scheduled <mark>meeting</mark>",
          D: "Restart his <mark>computer</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Contact IT support

대본 키워드: "If the problem persists, we might need to contact IT support."
보기 키워드: "Contact IT support"

❌ 오답 트랩:
(A) Switch to another network → 다른 네트워크 전환 언급 없음
(C) Postpone a scheduled meeting → 회의 연기 언급 없음
(D) Restart his computer → 컴퓨터 재시작 언급 없음`,
      },
    ],
  },
  conversation15: {
    id: 16,
    title: "Air Conditioner & Heating Issues",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage16.mp3",
        script: `<mark>M</mark>: Claire, is the <mark>air conditioning</mark> working on your side of the office? It feels really <mark>warm</mark> in here.
<span class="translation">(Claire, 사무실 당신 쪽의 에어컨이 작동하고 있나요? 여기가 정말 덥네요.)</span>

<mark>W</mark>: No, I noticed the same thing. I tried adjusting the <mark>thermostat</mark>, but nothing changed.
<span class="translation">(아니요, 저도 같은 걸 느꼈어요. 온도조절기를 조정해봤는데 아무것도 변화가 없었어요.)</span>

<mark>M</mark>: Maybe the filter is clogged. Should we call <mark>building maintenance</mark>?
<span class="translation">(아마도 필터가 막힌 것 같아요. 건물 관리팀에 연락해볼까요?)</span>

<mark>W</mark>: That's probably a good idea. I'll <mark>report the issue</mark> now.
<span class="translation">(좋은 생각인 것 같아요. 지금 문제를 보고하도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem do <mark>the speakers</mark> mention?",
        options: {
          A: "The <mark>lights</mark> in the office are too dim",
          B: "The <mark>ventilation system</mark> is leaking",
          C: "The <mark>air conditioning</mark> is not functioning properly",
          D: "The <mark>heating system</mark> is making noise",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The air conditioning is not functioning properly

대본 키워드: "Is the air conditioning working?" / "It feels really warm in here."
보기 키워드: "The air conditioning is not functioning properly"

❌ 오답 트랩:
(A) The lights in the office are too dim 
→ 조명 문제 언급 없음

(B) The ventilation system is leaking 
→ 환기 시스템 누수 언급 없음

(D) The heating system is making noise 
→ 난방 시스템 소음 언급 없음`,
      },
      {
        id: 2,
        question: "What did <mark>the woman</mark> try doing?",
        options: {
          A: "Changing the <mark>thermostat</mark> settings",
          B: "Turning the <mark>air conditioner</mark> <mark>off and on</mark>",
          C: "Opening the <mark>windows</mark>",
          D: "Checking the <mark>power supply</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Changing the thermostat settings

대본 키워드: "I tried adjusting the thermostat, but nothing changed."
보기 키워드: "Changing the thermostat settings"

❌ 오답 트랩:
(B) Turning the air conditioner off and on 
→ 전원 껐다 켜기 시도 언급 없음

(C) Opening the windows 
→ 창문 열기 언급 없음
(D) Checking the power supply 
→ 전원 공급 확인 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "<mark>Report</mark> the issue to <mark>building maintenance</mark>",
          B: "<mark>Move</mark> to a different office <mark>space</mark>",
          C: "Purchase a <mark>portable</mark> <mark>air conditioner</mark>",
          D: "<mark>Ask</mark> a <mark>coworker</mark> to <mark>fix</mark> the problem",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Report the issue to building maintenance

대본 키워드: "That's probably a good idea. I'll report the issue now."
보기 키워드: "Report the issue to building maintenance"

❌ 오답 트랩:
(B) Move to a different office space 
→ 다른 사무실로 이동 언급 없음

(C) Purchase a portable air conditioner 
→ 이동식 에어컨 구매 언급 없음

(D) Ask a coworker to fix the problem
→ 동료에게 수리 요청 언급 없음`,
      },
    ],
  },
  conversation16: {
    id: 17,
    title: "Flexible Work Hours",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage17.mp3",
        script: `<mark>M</mark>: Hi, Olivia. Did you see the announcement about the new <mark>flexible work hours policy</mark>?
<span class="translation">(안녕하세요, Olivia. 새로운 유연 근무제 정책에 대한 공지를 보셨나요?)</span>

<mark>W</mark>: Yes, it sounds interesting. So, employees can now <mark>choose when to start</mark> their workday?
<span class="translation">(네, 흥미로워 보이네요. 그러면 직원들이 이제 근무 시작 시간을 선택할 수 있는 건가요?)</span>

<mark>M</mark>: That's right. They can start anytime between <mark>7 AM and 10 AM</mark> as long as they complete eight hours.
<span class="translation">(맞아요. 8시간만 채우면 오전 7시에서 10시 사이에 언제든 시작할 수 있어요.)</span>

<mark>W</mark>: That's great. Do we need to inform <mark>HR</mark> about our preferred schedule?
<span class="translation">(좋네요. 우리가 선호하는 스케줄을 인사부에 알려야 하나요?)</span>

<mark>M</mark>: Yes, we have to <mark>submit our request</mark> by Friday afternoon so they can finalize the work shifts.
<span class="translation">(네, 근무 교대를 확정할 수 있도록 금요일 오후까지 우리의 요청을 제출해야 해요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> mainly discussing?",
        options: {
          A: "A <mark>salary</mark> adjustment policy",
          B: "A change in <mark>work hours</mark>",
          C: "An upcoming <mark>training</mark> session",
          D: "A company <mark>event</mark> schedule",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A change in work hours

대본 키워드: "Did you see the announcement about the new flexible work hours policy?"
보기 키워드: "A change in work hours"

❌ 오답 트랩:
(A) A salary adjustment policy 
→ 급여 조정 관련 언급 없음

(C) An upcoming training session 
→ 교육 일정 언급 없음

(D) A company event schedule 
→ 회사 행사 일정 언급 없음`,
      },
      {
        id: 2,
        question: "What is mentioned about the new policy?",
        options: {
          A: "Employees must work the <mark>same hours</mark> each day",
          B: "Employees can choose their <mark>start time</mark>",
          C: "The policy will be reviewed <mark>next year</mark>",
          D: "The company has shortened the <mark>workweek</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Employees can choose their start time

대본 키워드: "They can start anytime between 7 AM and 10 AM."
보기 키워드: "Employees can choose their start time"

❌ 오답 트랩:
(A) Employees must work the same hours each day 
→ 매일 같은 시간 근무해야 한다는 언급 없음

(C) The policy will be reviewed next year 
→ 정책 검토 시기 언급 없음

(D) The company has shortened the workweek 
→ 근무 주간 단축 언급 없음`,
      },
      {
        id: 3,
        question: "What must employees do by <mark>Friday</mark>?",
        options: {
          A: "<mark>Attend</mark> a policy briefing",
          B: "<mark>Submit</mark> their schedule preference",
          C: "<mark>Start</mark> working under the new policy",
          D: "<mark>Request</mark> additional <mark>vacation</mark> days",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Submit their schedule preference

대본 키워드: "We have to submit our request by Friday afternoon."
보기 키워드: "Submit their schedule preference"

❌ 오답 트랩:
(A) Attend a policy briefing 
→ 정책 브리핑 참석 언급 없음

(C) Start working under the new policy 
→ 새 정책 시행 시작일 언급 없음

(D) Request additional vacation days 
→ 추가 휴가 요청 언급 없음`,
      },
    ],
  },
  conversation17: {
    id: 18,
    title: "Weekend Work Adjustment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage18.mp3",
        script: `<mark>W</mark>: Hi, David. I noticed my name is on the schedule for this <mark>Saturday</mark>. Is that correct?
<span class="translation">(안녕하세요, David. 이번 토요일 스케줄에 제 이름이 있는 걸 봤는데요. 맞나요?)</span>

<mark>M</mark>: Yes, we need at least one person from each department to be available. Can you work that day?
<span class="translation">(네, 각 부서에서 최소 한 명은 있어야 해서요. 그날 근무 가능하신가요?)</span>

<mark>W</mark>: I was hoping to swap with someone since I have a <mark>family commitment</mark>. Would it be possible to adjust the schedule?
<span class="translation">(가족 행사가 있어서 다른 사람과 바꾸고 싶은데요. 스케줄 조정이 가능할까요?)</span>

<mark>M</mark>: That should be fine. I'll check if another <mark>team member</mark> can cover your shift.
<span class="translation">(괜찮을 것 같아요. 다른 팀원이 당신의 근무를 대신할 수 있는지 확인해보겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the woman</mark> asking about?",
        options: {
          A: "The company's <mark>overtime</mark> policy",
          B: "A <mark>training</mark> session this <mark>weekend</mark>",
          C: "Whether she is scheduled to work on <mark>Saturday</mark>",
          D: "A <mark>business trip</mark> assignment",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Whether she is scheduled to work on Saturday

대본 키워드: "I noticed my name is on the schedule for this Saturday. Is that correct?"
보기 키워드: "Whether she is scheduled to work on Saturday"

❌ 오답 트랩:
(A) The company's overtime policy 
→ 초과 근무 정책 관련 언급 없음

(B) A training session this weekend 
→ 교육 관련 언급 없음

(D) A business trip assignment 
→ 출장 관련 언급 없음`,
      },
      {
        id: 2,
        question:
          "Why does <mark>the woman</mark> want to change her schedule?",
        options: {
          A: "She prefers to work on <mark>Sunday</mark>",
          B: "She has an important <mark>personal event</mark>",
          C: "She has to attend a <mark>meeting</mark>",
          D: "She is <mark>feeling unwell</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) She has an important personal event

대본 키워드: "I have a family commitment."
보기 키워드: "She has an important personal event"

❌ 오답 트랩:
(A) She prefers to work on Sunday 
→ 일요일 근무 선호 언급 없음

(C) She has to attend a meeting 
→ 회의 참석 언급 없음

(D) She is feeling unwell 
→ 건강 상태 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Check</mark> if someone else can cover her <mark>shift</mark>",
          B: "<mark>Approve</mark> her <mark>vacation</mark> request",
          C: "<mark>Assign</mark> her to a different <mark>project</mark>",
          D: "Ask her to work <mark>additional hours</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check if someone else can cover her shift

대본 키워드: "I'll check if another team member can cover your shift."
보기 키워드: "Check if someone else can cover her shift"

❌ 오답 트랩:
(A) Approve her vacation request 
→ 휴가 승인 언급 없음

(C) Assign her to a different project 
→ 다른 프로젝트 배정 언급 없음

(D) Ask her to work additional hours 
→ 추가 근무 요청 언급 없음`,
      },
    ],
  },
  conversation18: {
    id: 19,
    title: "Vacation Request",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage19.mp3",
        script: `<mark>M</mark>: Hi, Kelly. I'd like to request some <mark>time off</mark> next month. Can you remind me of the process?
<span class="translation">(안녕하세요, Kelly. 다음 달에 휴가를 신청하고 싶은데요. 절차를 알려주실 수 있나요?)</span>

<mark>W</mark>: Sure. You need to submit a request through the company's <mark>HR portal</mark> at least <mark>two weeks</mark> in advance.
<span class="translation">(네. 최소 2주 전에 회사 HR 포털을 통해 신청서를 제출하셔야 해요.)</span>

<mark>M</mark>: That makes sense. Does my <mark>manager</mark> need to approve it first?
<span class="translation">(그렇군요. 매니저가 먼저 승인해야 하나요?)</span>

<mark>W</mark>: Yes, your request will be sent to your <mark>supervisor</mark> for approval. Once it's approved, <mark>HR will update</mark> the schedule.
<span class="translation">(네, 신청서가 승인을 위해 상사에게 전달될 거예요. 승인되면 HR에서 일정을 업데이트할 거예요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the man</mark> ask about?",
        options: {
          A: "How to request <mark>vacation leave</mark>",
          B: "The company's <mark>sick leave</mark> policy",
          C: "<mark>Reimbursement</mark> for a business <mark>trip</mark>",
          D: "How to adjust his <mark>work</mark> <mark>schedule</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) How to request vacation leave

대본 키워드: "I'd like to request some time off next month. Can you remind me of the process?"
보기 키워드: "How to request vacation leave"

❌ 오답 트랩:
(B) The company's sick leave policy 
→ 병가 관련 언급 없음

(C) Reimbursement for a business trip 
→ 출장 경비 관련 언급 없음

(D) How to adjust his work schedule 
→ 근무 시간 조정이 아니라 휴가 신청 문의`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> say about the process?",
        options: {
          A: "The request must be submitted <mark>in person</mark>",
          B: "It must be approved by a <mark>manager</mark>",
          C: "Employees can only take vacation in <mark>December</mark>",
          D: "The <mark>HR department</mark> automatically approves requests",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) It must be approved by a manager

대본 키워드: "Your request will be sent to your supervisor for approval."
보기 키워드: "It must be approved by a manager"

❌ 오답 트랩:
(A) The request must be submitted in person 
→ HR 포털을 통해 제출해야 함

(C) Employees can only take vacation in December 
→ 휴가 제한 기간 언급 없음

(D) The HR department automatically approves requests 
→ HR이 아니라 매니저가 승인`,
      },
      {
        id: 3,
        question: "What will happen after the request is approved?",
        options: {
          A: "The employee must <mark>resubmit</mark> the request",
          B: "<mark>HR</mark> will <mark>update</mark> the <mark>schedule</mark>",
          C: "The vacation days will be deducted from the <mark>salary</mark>",
          D: "The employee must <mark>train</mark> a <mark>replacement</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) HR will update the schedule

대본 키워드: "Once it's approved, HR will update the schedule."
보기 키워드: "HR will update the schedule"

❌ 오답 트랩:
(A) The employee must resubmit the request 
→ 재신청 필요 언급 없음

(C) The vacation days will be deducted from the salary 
→ 급여 공제 언급 없음

(D) The employee must train a replacement 
→ 대체 인력 교육 언급 없음`,
      },
    ],
  },
  conversation19: {
    id: 20,
    title: "Salary Negotiation",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage20.mp3",
        script: `<mark>M</mark>: Hi, Rachel. I'd like to discuss my <mark>salary adjustment</mark>. My <mark>contract</mark> is up for renewal next month.
<span class="translation">(안녕하세요, Rachel. 제 급여 조정에 대해 논의하고 싶습니다. 다음 달에 계약 갱신이 있어서요.)</span>

<mark>W</mark>: Of course. The company reviews salary adjustments annually. Have you checked the <mark>performance review</mark> guidelines?
<span class="translation">(물론이죠. 회사는 연간 급여 조정을 검토하는데요. 성과 평가 지침을 확인해보셨나요?)</span>

<mark>M</mark>: Yes, I met most of my <mark>targets</mark>, and I also completed two major projects ahead of schedule.
<span class="translation">(네, 대부분의 목표를 달성했고, 주요 프로젝트 두 개도 일정보다 앞서 완료했습니다.)</span>

<mark>W</mark>: That's great. Submit your request in <mark>writing</mark>, and I'll forward it to HR for review.
<span class="translation">(잘하셨네요. 요청서를 서면으로 제출해 주시면 HR에 검토를 위해 전달하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "Why does <mark>the man</mark> want to discuss his salary?",
        options: {
          A: "His <mark>contract</mark> is up for <mark>renewal</mark>",
          B: "The company is offering <mark>bonuses</mark>",
          C: "He received a <mark>job offer</mark> elsewhere",
          D: "The company changed its <mark>payroll</mark> system",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) His contract is up for renewal

대본 키워드: "My contract is up for renewal next month."
보기 키워드: "His contract is up for renewal"

❌ 오답 트랩:
(B) The company is offering bonuses 
→ 보너스 제공 언급 없음

(C) He received a job offer elsewhere 
→ 다른 회사 제안 언급 없음

(D) The company changed its payroll system 
→ 급여 시스템 변경 언급 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> ask the man?",
        options: {
          A: "If he has reviewed the <mark>salary policy</mark>",
          B: "If he is planning to <mark>leave</mark> the <mark>company</mark>",
          C: "If he wants to <mark>transfer</mark> <mark>departments</mark>",
          D: "If he completed the <mark>performance</mark> <mark>review</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) If he completed the performance review

대본 키워드: "Have you checked the performance review guidelines?"
보기 키워드: "If he completed the performance review"

❌ 오답 트랩:
(A) If he has reviewed the salary policy 
→ 급여 정책 검토 여부 언급 없음

(B) If he is planning to leave the company 
→ 퇴사 계획 언급 없음

(C) If he wants to transfer departments 
→ 부서 이동 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Submit a <mark>formal</mark> <mark>salary</mark> <mark>request</mark>",
          B: "Meet with a <mark>financial</mark> <mark>advisor</mark>",
          C: "Request additional <mark>benefits</mark>",
          D: "<mark>Resign</mark> from the company",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Submit a formal salary request

대본 키워드: "Submit your request in writing, and I'll forward it to HR for review."
보기 키워드: "Submit a formal salary request"

❌ 오답 트랩:
(B) Meet with a financial advisor 
→ 재무 상담사 미팅 언급 없음

(C) Request additional benefits 
→ 추가 혜택 요청 언급 없음

(D) Resign from the company 
→ 퇴사 언급 없음`,
      },
    ],
  },
  conversation20: {
    id: 21,
    title: "Job Posting for New & Experienced Employees",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage21.mp3",
        script: `<mark>M</mark>: Hi, Rachel. I saw that the company is <mark>hiring</mark> for a new sales associate position. Is this for <mark>entry-level</mark> candidates or experienced professionals?
<span class="translation">(안녕하세요, Rachel. 회사에서 새로운 영업 담당자를 채용한다고 봤는데요. 신입 지원자를 뽑나요, 아니면 경력직을 뽑나요?)</span>

<mark>W</mark>: Actually, we're hiring for both. We need one <mark>junior associate</mark> and one <mark>senior representative</mark>.
<span class="translation">(사실 둘 다 채용하려고 해요. 주니어 담당자 한 명과 시니어 담당자 한 명이 필요해서요.)</span>

<mark>M</mark>: That makes sense. Where can applicants find more details about the <mark>job postings</mark>?
<span class="translation">(그렇군요. 지원자들은 채용 공고에 대한 자세한 내용을 어디서 볼 수 있나요?)</span>

<mark>W</mark>: The listings are available on our <mark>company website</mark>, and we also posted them on a few online job platforms.
<span class="translation">(공고는 회사 웹사이트에서 볼 수 있고, 몇 개의 온라인 채용 플랫폼에도 올려놨어요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A recent <mark>job</mark> <mark>interview</mark>",
          B: "A company's <mark>hiring</mark> <mark>process</mark>",
          C: "A <mark>training</mark> <mark>session</mark> for new employees",
          D: "An <mark>internal</mark> <mark>promotion</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A company's hiring process

대본 키워드: "The company is hiring for a new sales associate position."
보기 키워드: "A company's hiring process"

❌ 오답 트랩:
(A) A recent job interview 
→ 채용 공고에 대한 논의이지 면접 관련 내용 아님

(C) A training session for new employees 
→ 교육이 아니라 채용 과정 논의

(D) An internal promotion 
→ 승진이 아니라 신입/경력 채용 공고 논의`,
      },
      {
        id: 2,
        question:
          "What does <mark>the woman</mark> say about the job openings?",
        options: {
          A: "<mark>Only</mark> <mark>entry-level</mark> positions are available",
          B: "Both <mark>junior</mark> <mark>and</mark> <mark>senior</mark> positions are open",
          C: "The company is <mark>only</mark> hiring <mark>internally</mark>",
          D: "The job postings will be <mark>removed</mark> <mark>soon</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Both junior and senior positions are open

대본 키워드: "We need one junior associate and one senior representative."
보기 키워드: "Both junior and senior positions are open"

❌ 오답 트랩:
(A) Only entry-level positions are available 
→ 신입만이 아닌 경력직도 채용

(C) The company is only hiring internally 
→ 내부 채용이 아닌 외부 채용

(D) The job postings will be removed soon 
→ 공고 삭제 예정 언급 없음`,
      },
      {
        id: 3,
        question: "Where can applicants find information about the jobs?",
        options: {
          A: "On the <mark>company</mark> <mark>website</mark>",
          B: "In the employee <mark>handbook</mark>",
          C: "In a <mark>newspaper</mark> <mark>advertisement</mark>",
          D: "Through a <mark>recruitment</mark> <mark>agency</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) On the company website

대본 키워드: "The listings are available on our company website."
보기 키워드: "On the company website"

❌ 오답 트랩:
(B) In the employee handbook 
→ 직원 핸드북 언급 없음

(C) In a newspaper advertisement 
→ 신문 광고 언급 없음

(D) Through a recruitment agency 
→ 채용 대행사 언급 없음`,
      },
    ],
  },
  conversation21: {
    id: 22,
    title: "Interview Schedule Adjustment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage22.mp3",
        script: `<mark>W</mark>: Hi, Jason. I just received an email from one of the <mark>candidates</mark> for the marketing position. He's requesting to <mark>reschedule</mark> his interview.
<span class="translation">(안녕하세요, Jason. 마케팅 포지션 지원자 중 한 명에게서 이메일을 받았어요. 면접 일정 변경을 요청하네요.)</span>
<mark>M</mark>: Did he mention the reason?
<span class="translation">(이유를 언급했나요?)</span>

<mark>W</mark>: Yes, he has a scheduling <mark>conflict</mark> with another interview. He's asking if we can move it to <mark>Thursday morning</mark>.
<span class="translation">(네, 다른 면접과 일정이 겹친다고 해요. 목요일 오전으로 옮길 수 있는지 문의하네요.)</span>

<mark>M</mark>: Let me check if the <mark>hiring manager</mark> is available at that time. If not, we may need to find another slot.
<span class="translation">(채용 담당자가 그 시간에 가능한지 확인해볼게요. 안 되면 다른 시간을 찾아봐야 할 것 같네요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation about?",
        options: {
          A: "A <mark>job</mark> <mark>offer</mark> for a candidate",
          B: "A change in an <mark>interview</mark> <mark>schedule</mark>",
          C: "A <mark>training</mark> <mark>session</mark> for new hires",
          D: "A <mark>job fair</mark> event",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A change in an interview schedule

대본 키워드: "He's requesting to reschedule his interview."
보기 키워드: "A change in an interview schedule"

❌ 오답 트랩:
(A) A job offer for a candidate 
→ 채용 결정이 아니라 면접 일정 조정 논의

(C) A training session for new hires 
→ 교육이 아니라 면접 관련 내용

(D) A job fair event 
→ 채용 박람회 관련 언급 없음`,
      },
      {
        id: 2,
        question: "Why does <mark>the candidate</mark> want to reschedule?",
        options: {
          A: "He has a <mark>personal</mark> <mark>emergency</mark>",
          B: "He is <mark>traveling</mark> for work",
          C: "He has <mark>another</mark> <mark>interview</mark> at the same time",
          D: "The <mark>hiring</mark> <mark>manager</mark> is unavailable",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) He has another interview at the same time

대본 키워드: "He has a scheduling conflict with another interview."
보기 키워드: "He has another interview at the same time"

❌ 오답 트랩:
(A) He has a personal emergency 
→ 개인적인 긴급 상황 언급 없음

(B) He is traveling for work 
→ 출장 관련 언급 없음

(D) The hiring manager is unavailable 
→ 채용 담당자 불가 여부는 아직 확인 전`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Confirm the <mark>new</mark> <mark>interview</mark> time",
          B: "<mark>Cancel</mark> the candidate's <mark>interview</mark>",
          C: "<mark>Ask</mark> the <mark>candidate</mark> to choose a different <mark>day</mark>",
          D: "Check the <mark>hiring manager's</mark> availability",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Check the hiring manager's availability

대본 키워드: "Let me check if the hiring manager is available at that time."
보기 키워드: "Check the hiring manager's availability"

❌ 오답 트랩:
(A) Confirm the new interview time 
→ 담당자 확인 전 시간 확정 불가

(B) Cancel the candidate's interview 
→ 면접 취소 언급 없음

(C) Ask the candidate to choose a different day 
→ 다른 날짜 요청 언급 없음`,
      },
    ],
  },
  conversation22: {
    id: 23,
    title: "Job Offer Announcement",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage23.mp3",
        script: `<mark>M</mark>: Hi, Sarah. We've made our <mark>final decision</mark> for the software engineer position.
<span class="translation">(안녕하세요, Sarah. 소프트웨어 엔지니어 포지션에 대한 최종 결정을 내렸어요.)</span>

<mark>W</mark>: That's great! Who are we extending the <mark>job offer</mark> to?
<span class="translation">(좋네요! 누구에게 채용 제안을 하기로 했나요?)</span>

<mark>M</mark>: We selected <mark>James Carter</mark>. He had strong <mark>technical skills</mark> and excellent problem-solving abilities.
<span class="translation">(James Carter를 선택했어요. 그는 뛰어난 기술력과 훌륭한 문제 해결 능력을 가지고 있었죠.)</span>

<mark>W</mark>: That's a solid choice. Should I prepare the <mark>offer letter</mark> and send it to him today?
<span class="translation">(좋은 선택이네요. 오늘 채용 제안서를 준비해서 보내드릴까요?)</span>

<mark>M</mark>: Yes, and let's also notify the other candidates who weren't selected.
<span class="translation">(네, 그리고 선발되지 않은 다른 지원자들에게도 알려주세요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A <mark>job</mark> <mark>promotion</mark> announcement",
          B: "The <mark>final decision</mark> for a job <mark>candidate</mark>",
          C: "A company-wide <mark>restructuring</mark>",
          D: "A <mark>department transfer</mark> request",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The final decision for a job candidate

대본 키워드: "We've made our final decision for the software engineer position."
보기 키워드: "The final decision for a job candidate"

❌ 오답 트랩:
(A) A job promotion announcement 
→ 승진 발표가 아닌 신규 채용 결정

(C) A company-wide restructuring 
→ 회사 구조조정 언급 없음

(D) A department transfer request 
→ 부서 이동 요청 언급 없음`,
      },
      {
        id: 2,
        question:
          "Why was <mark>James Carter</mark> selected for the position?",
        options: {
          A: "He had strong <mark>technical skills</mark>",
          B: "He had <mark>prior</mark> <mark>experience</mark> at the company",
          C: "He received a <mark>recommendation</mark> from the <mark>CEO</mark>",
          D: "He was the only <mark>applicant</mark> for the job",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) He had strong technical skills

대본 키워드: "He had strong technical skills and excellent problem-solving abilities."
보기 키워드: "He had strong technical skills"

❌ 오답 트랩:
(B) He had prior experience at the company 
→ 회사 경력 언급 없음

(C) He received a recommendation from the CEO 
→ CEO 추천 언급 없음

(D) He was the only applicant for the job 
→ 유일한 지원자가 아님`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Prepare the <mark>job</mark> <mark>offer letter</mark>",
          B: "Schedule an <mark>onboarding</mark> session",
          C: "Arrange a <mark>welcome</mark> <mark>party</mark> for the new hire",
          D: "Conduct <mark>another</mark> round of <mark>interviews</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Prepare the job offer letter

대본 키워드: "Should I prepare the offer letter and send it to him today?"
보기 키워드: "Prepare the job offer letter"

❌ 오답 트랩:
(B) Schedule an onboarding session 
→ 온보딩 일정 언급 없음

(C) Arrange a welcome party for the new hire 
→ 환영회 준비 언급 없음

(D) Conduct another round of interviews 
→ 추가 면접 진행 언급 없음`,
      },
    ],
  },
  conversation23: {
    id: 24,
    title: "Internal Promotion Announcement",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage24.mp3",
        script: `<mark>M</mark>: Hi, Susan. Have you heard about the <mark>promotion</mark> announcements? Michael has been promoted to <mark>senior manager</mark>!
<span class="translation">(안녕하세요, Susan. 승진 발표 소식 들으셨나요? Michael이 수석 매니저로 승진했어요!)</span>

<mark>W</mark>: Really? That's great news! He's been with the company for a <mark>long time</mark>, and he definitely deserves it.
<span class="translation">(정말요? 좋은 소식이네요! 그는 회사에서 오랫동안 일해왔고, 정말 받을 만해요.)</span>

<mark>M</mark>: Yes, and with his promotion, there will be some team <mark>restructuring</mark>. We might get a new supervisor soon.
<span class="translation">(네, 그리고 그의 승진으로 팀 개편이 있을 거예요. 곧 새로운 상사를 맞이하게 될 것 같아요.)</span>

<mark>W</mark>: That makes sense. Do we know who will be replacing him in his previous role?
<span class="translation">(그렇군요. 그의 이전 역할을 누가 대신하게 될지 알고 있나요?)</span>

<mark>M</mark>: Not yet. The <mark>management team</mark> is still reviewing candidates.
<span class="translation">(아직이요. 경영진이 아직 후보자들을 검토 중이에요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A company-wide training <mark>program</mark>",
          B: "A recent <mark>promotion</mark> announcement",
          C: "A <mark>salary</mark> adjustment <mark>policy</mark>",
          D: "A new employee's <mark>first</mark> <mark>day</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A recent promotion announcement

대본 키워드: "Have you heard about the promotion announcements?"
보기 키워드: "A recent promotion announcement"

❌ 오답 트랩:
(A) A company-wide training program 
→ 교육이 아니라 승진 발표 관련 내용

(C) A salary adjustment policy 
→ 급여 조정이 아니라 승진 논의

(D) A new employee's first day 
→ 신입 직원 관련 언급 없음`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> say about Michael?",
        options: {
          A: "He has <mark>worked</mark> at the company for <mark>many</mark> <mark>years</mark>",
          B: "He <mark>recently joined</mark> the organization",
          C: "He is moving to <mark>another</mark> <mark>department</mark>",
          D: "He has requested <mark>additional</mark> <mark>training</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) He has worked at the company for many years

대본 키워드: "He's been with the company for a long time."
보기 키워드: "He has worked at the company for many years"

❌ 오답 트랩:
(B) He recently joined the organization 
→ 최근 입사가 아닌 오랜 경력자

(C) He is moving to another department 
→ 부서 이동 언급 없음

(D) He has requested additional training 
→ 추가 교육 요청 언급 없음`,
      },
      {
        id: 3,
        question:
          "What does <mark>the man</mark> say about Michael's former position?",
        options: {
          A: "It has already been <mark>filled</mark>",
          B: "The <mark>management team</mark> is still selecting a replacement",
          C: "<mark>Susan</mark> has been chosen to take over",
          D: "The position has been <mark>eliminated</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The management team is still selecting a replacement

대본 키워드: "The management team is still reviewing candidates."
보기 키워드: "The management team is still selecting a replacement"

❌ 오답 트랩:
(A) It has already been filled 
→ 자리가 채워지지 않고 검토 중

(C) Susan has been chosen to take over 
→ Susan 선발 언급 없음

(D) The position has been eliminated 
→ 자리 폐지 언급 없음`,
      },
    ],
  },
  conversation24: {
    id: 25,
    title: "Department Transfer",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage25.mp3",
        script: `<mark>W</mark>: Hi, Alex. I heard you're <mark>transferring</mark> to the marketing department next month. Is that true?
<span class="translation">(안녕하세요, Alex. 다음 달에 마케팅 부서로 이동한다고 들었는데, 사실인가요?)</span>

<mark>M</mark>: Yes, my manager spoke with me last week. They need someone with <mark>project management</mark> experience, and I've been handling a lot of event planning lately.
<span class="translation">(네, 지난주에 매니저가 저와 이야기했어요. 프로젝트 관리 경험이 있는 사람이 필요하다고 하더라고요. 제가 최근에 이벤트 기획을 많이 해왔거든요.)</span>

<mark>W</mark>: That's a great opportunity. Will you be working with the same clients?
<span class="translation">(좋은 기회네요. 같은 고객들과 일하게 되나요?)</span>

<mark>M</mark>: No, my focus will shift to <mark>product launches</mark> instead of client outreach. It's a different challenge, but I'm excited.
<span class="translation">(아니요, 고객 관리 대신 제품 출시에 집중하게 될 거예요. 다른 도전이지만 기대됩니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the woman</mark> ask the man?",
        options: {
          A: "If he is <mark>switching</mark> to a <mark>different</mark> <mark>department</mark>",
          B: "If he is taking on a <mark>management</mark> <mark>role</mark>",
          C: "If he will be working <mark>abroad</mark>",
          D: "If he has accepted a <mark>new</mark> <mark>job</mark> <mark>offer</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) If he is switching to a different department

대본 키워드: "I heard you're transferring to the marketing department next month. Is that true?"
보기 키워드: "If he is switching to a different department"

❌ 오답 트랩:
(B) If he is taking on a management role 
→ 관리직 이동 언급 없음

(C) If he will be working abroad 
→ 해외 근무 관련 내용 없음

(D) If he has accepted a new job offer 
→ 회사 내 부서 이동이지 새로운 회사가 아님`,
      },
      {
        id: 2,
        question: "Why was <mark>the man</mark> transferred?",
        options: {
          A: "The company needed someone with <mark>project</mark> <mark>management</mark> <mark>skills</mark>",
          B: "His previous department was <mark>downsized</mark>",
          C: "He <mark>applied</mark> for a position in <mark>another</mark> <mark>division</mark>",
          D: "He <mark>requested</mark> a role with fewer <mark>responsibilities</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) The company needed someone with project management skills

대본 키워드: "They need someone with project management experience."
보기 키워드: "The company needed someone with project management skills"

❌ 오답 트랩:
(B) His previous department was downsized 
→ 부서 축소 언급 없음

(C) He applied for a position in another division 
→ 자발적 지원이 아닌 회사 필요에 의한 이동

(D) He requested a role with fewer responsibilities 
→ 책임 축소 요청 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man's</mark> new role focus on?",
        options: {
          A: "Managing a client <mark>outreach</mark> <mark>program</mark>",
          B: "Overseeing <mark>product</mark> <mark>launches</mark>",
          C: "Handling employee <mark>recruitment</mark>",
          D: "Organizing <mark>corporate</mark> <mark>training</mark> <mark>sessions</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Overseeing product launches

대본 키워드: "My focus will shift to product launches instead of client outreach."
보기 키워드: "Overseeing product launches"

❌ 오답 트랩:
(A) Managing a client outreach program 
→ 고객 관리에서 제품 출시로 변경됨

(C) Handling employee recruitment 
→ 직원 채용 업무 언급 없음

(D) Organizing corporate training sessions 
→ 기업 교육 진행 언급 없음`,
      },
    ],
  },
  conversation25: {
    id: 26,
    title: "Overseas Assignment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage26.mp3",
        script: `<mark>M</mark>: Hi, Claire. I just heard that you've been selected for the six-month <mark>assignment</mark> in Singapore. Congratulations!
<span class="translation">(안녕하세요, Claire. 방금 싱가포르 6개월 파견 근무에 선발되었다고 들었어요. 축하드려요!)</span>

<mark>W</mark>: Thank you! I'm really <mark>excited</mark> about it. It'll be a great opportunity to work closely with our international partners.
<span class="translation">(감사합니다! 정말 신나요. 우리 해외 파트너들과 긴밀하게 일할 수 있는 좋은 기회가 될 것 같아요.)</span>

<mark>M</mark>: When will you be leaving?
<span class="translation">(언제 떠나시나요?)</span>

<mark>W</mark>: I'll be relocating in mid-July. I need to complete a <mark>training session</mark> before I go.
<span class="translation">(7월 중순에 이동할 예정이에요. 가기 전에 교육을 이수해야 해요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What opportunity was <mark>the woman</mark> given?",
        options: {
          A: "A leadership <mark>training</mark> <mark>program</mark>",
          B: "A <mark>six-month</mark> overseas assignment",
          C: "A chance to work in a <mark>different</mark> <mark>department</mark>",
          D: "A promotion to <mark>senior</mark> <mark>manager</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A six-month overseas assignment

대본 키워드: "You've been selected for the six-month assignment in Singapore."
보기 키워드: "A six-month overseas assignment"

❌ 오답 트랩:
(A) A leadership training program 
→ 리더십 교육이 아닌 해외 파견

(C) A chance to work in a different department 
→ 부서 이동이 아닌 해외 파견

(D) A promotion to senior manager 
→ 승진이 아닌 해외 파견`,
      },
      {
        id: 2,
        question: "How does <mark>the woman</mark> feel about the assignment?",
        options: {
          A: "She is <mark>nervous</mark> about relocating",
          B: "She is <mark>excited</mark> about the opportunity",
          C: "She is <mark>unsure</mark> about the decision",
          D: "She is <mark>reluctant</mark> to leave her current team",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) She is excited about the opportunity

대본 키워드: "I'm really excited about it."
보기 키워드: "She is excited about the opportunity"

❌ 오답 트랩:
(A) She is nervous about relocating 
→ 긴장이 아닌 기대감 표현

(C) She is unsure about the decision 
→ 불확실함이 아닌 확신에 찬 태도

(D) She is reluctant to leave her current team 
→ 현재 팀 이탈 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What must <mark>the woman</mark> do before relocating?",
        options: {
          A: "Complete a <mark>training</mark> <mark>session</mark>",
          B: "Meet with her <mark>new</mark> <mark>team</mark>",
          C: "Find a temporary <mark>apartment</mark>",
          D: "<mark>Submit</mark> a relocation <mark>request</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Complete a training session

대본 키워드: "I need to complete a training session before I go."
보기 키워드: "Complete a training session"

❌ 오답 트랩:
(B) Meet with her new team 
→ 새 팀 미팅 언급 없음

(C) Find a temporary apartment 
→ 임시 거처 찾기 언급 없음

(D) Submit a relocation request 
→ 이동 요청서 제출 언급 없음`,
      },
    ],
  },
  conversation26: {
    id: 27,
    title: "Booking a Flight",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage27.mp3",
        script: `<mark>W</mark>: Hi, Brian. I'm booking <mark>flights</mark> for your business trip to Toronto next month. Do you have a preferred airline?
<span class="translation">(안녕하세요, Brian. 다음 달 토론토 출장 항공권을 예약하고 있는데요. 선호하는 항공사가 있으신가요?)</span>

<mark>M</mark>: Not really, but I'd prefer a <mark>direct flight</mark> if possible.
<span class="translation">(특별히 없지만, 가능하다면 직항편이 좋겠어요.)</span>

<mark>W</mark>: I checked a few options. There's a morning flight with <mark>GreenSky Airlines</mark> that's non-stop, or an afternoon one with SkyWest that has a layover in New York.
<span class="translation">(몇 가지 옵션을 확인해봤어요. GreenSky Airlines의 아침 직항편이 있고, 또는 SkyWest의 오후 편은 뉴욕에서 경유가 있네요.)</span>

<mark>M</mark>: Let's go with <mark>GreenSky Airlines</mark>. A direct flight will save time.
<span class="translation">(GreenSky Airlines로 하죠. 직항편이 시간을 절약할 수 있을 거예요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the woman</mark> helping the man with?",
        options: {
          A: "Booking a <mark>flight</mark> for his trip",
          B: "Reserving a <mark>rental</mark> <mark>car</mark>",
          C: "Registering for a <mark>conference</mark>",
          D: "Finding a <mark>hotel</mark> near the airport",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Booking a flight for his trip

대본 키워드: "I'm booking flights for your business trip to Toronto next month."
보기 키워드: "Booking a flight for his trip"

❌ 오답 트랩:
(B) Reserving a rental car 
→ 렌터카 예약 언급 없음

(C) Registering for a conference 
→ 컨퍼런스 등록 언급 없음

(D) Finding a hotel near the airport 
→ 호텔 예약 언급 없음`,
      },
      {
        id: 2,
        question: "What preference does <mark>the man</mark> mention?",
        options: {
          A: "He wants a <mark>window</mark> <mark>seat</mark>",
          B: "He prefers a <mark>direct</mark> <mark>flight</mark>",
          C: "He needs extra <mark>baggage</mark> <mark>allowance</mark>",
          D: "He prefers to fly at <mark>night</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) He prefers a direct flight

대본 키워드: "I'd prefer a direct flight if possible."
보기 키워드: "He prefers a direct flight"

❌ 오답 트랩:
(A) He wants a window seat 
→ 창가 좌석 선호 언급 없음

(C) He needs extra baggage allowance 
→ 수하물 추가 언급 없음

(D) He prefers to fly at night 
→ 야간 비행 선호 언급 없음`,
      },
      {
        id: 3,
        question: "Which flight does <mark>the man</mark> choose?",
        options: {
          A: "A morning flight with <mark>GreenSky Airlines</mark>",
          B: "A flight with a layover in <mark>New York</mark>",
          C: "A late-night flight with <mark>GlobalAir</mark>",
          D: "A discounted flight with <mark>SkyWest</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A morning flight with GreenSky Airlines

대본 키워드: "Let's go with GreenSky Airlines. A direct flight will save time."
보기 키워드: "A morning flight with GreenSky Airlines"

❌ 오답 트랩:
(B) A flight with a layover in New York 
→ 경유편이 아닌 직항편 선택

(C) A late-night flight with GlobalAir 
→ GlobalAir 항공편 언급 없음

(D) A discounted flight with SkyWest 
→ SkyWest 항공편 선택하지 않음`,
      },
    ],
  },

  conversation27: {
    id: 29,
    title: "Work Schedule Adjustment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/storage/storage29.mp3",
        script: `<mark>M</mark>: Hi, Jessica. I just received the updated work schedule, and I noticed that I'm assigned to work <mark>late shifts</mark> next week. I was wondering if there's any way to adjust that.
<span class="translation">(안녕하세요, Jessica. 방금 업데이트된 근무 일정을 받았는데, 다음 주에 야간 근무가 배정된 것을 봤어요. 혹시 조정이 가능할까요?)</span>

<mark>W</mark>: Oh, I see. We had to make some adjustments because a few employees requested <mark>vacation time</mark>. But let me check if I can rearrange things for you.
<span class="translation">(아, 그렇군요. 몇몇 직원들이 휴가를 신청해서 일정 조정이 필요했어요. 하지만 재조정이 가능한지 확인해보겠습니다.)</span>

<mark>M</mark>: That would be great. I have an important <mark>family event</mark> on Wednesday evening, so I'd really appreciate it if I could get an earlier shift that day.
<span class="translation">(감사합니다. 수요일 저녁에 중요한 가족 행사가 있어서, 그날만이라도 일찍 끝나는 근무로 바꿀 수 있다면 정말 감사하겠습니다.)</span>

<mark>W</mark>: I understand. I'll see if someone is available to <mark>swap shifts</mark> with you on Wednesday. I'll confirm with you by the end of the day.
<span class="translation">(알겠습니다. 수요일에 교대 근무가 가능한 사람이 있는지 확인해보겠습니다. 오늘 안으로 알려드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the conversation?",
        options: {
          A: "Organizing a company <mark>event</mark>",
          B: "Discussing a <mark>performance</mark> <mark>review</mark>",
          C: "Adjusting a work <mark>schedule</mark>",
          D: "Arranging a <mark>business</mark> <mark>trip</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Adjusting a work schedule

대본 키워드: "I noticed that I'm assigned to work late shifts next week. I was wondering if there's any way to adjust that."
보기 키워드: "Adjusting a work schedule"

❌ 오답 트랩:
(A) Organizing a company event 
→ 회사 행사가 아닌 근무 일정 조정 논의

(B) Discussing a performance review 
→ 성과 평가가 아닌 근무 일정 조정 논의

(D) Arranging a business trip 
→ 출장이 아닌 근무 일정 조정 논의`,
      },
      {
        id: 2,
        question: "Why was <mark>the man</mark> given a late shift?",
        options: {
          A: "He was assigned to a <mark>new</mark> <mark>project</mark>",
          B: "Some employees took <mark>vacation</mark>",
          C: "He requested to <mark>change</mark> his <mark>schedule</mark>",
          D: "The company introduced a <mark>new</mark> <mark>policy</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Some employees took vacation

대본 키워드: "We had to make some adjustments because a few employees requested vacation time."
보기 키워드: "Some employees took vacation"

❌ 오답 트랩:
(A) He was assigned to a new project 
→ 새 프로젝트 배정 언급 없음

(C) He requested to change his schedule 
→ 그가 변경을 요청한 것이 아님

(D) The company introduced a new policy 
→ 새로운 정책 도입 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Check if another employee can <mark>swap shifts</mark>",
          B: "<mark>Approve</mark> the man's <mark>vacation</mark> request",
          C: "Schedule a <mark>meeting</mark> for later",
          D: "<mark>Cancel</mark> the man's shift <mark>for the week</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check if another employee can swap shifts

대본 키워드: "I'll see if someone is available to swap shifts with you on Wednesday."
보기 키워드: "Check if another employee can swap shifts"

❌ 오답 트랩:
(B) Approve the man's vacation request 
→ 휴가 요청이 아닌 교대 근무 변경 요청

(C) Schedule a meeting for later 
→ 회의 일정 잡기 언급 없음

(D) Cancel the man's shift for the week 
→ 근무 취소가 아닌 교대 근무 변경 논의`,
      },
    ],
  },
};
